import React from "react"
import { navigate } from "gatsby"
import { graphql } from "gatsby"
import Layout from "src/components/core/templates/layout"
import Hero from "src/components/core/templates/hero"
import Button from "src/components/core/atoms/button"
import Seo from "src/components/seo"

const pageConfig = {
  title: "loading...",
  description: "",
  variant: "clouds",
}

const IndexPage = ({ data }) => {
  let title

  data
    ? (title = data.allPrismicHomepage.edges[0].node.data.title[0].text)
    : (title = "loading...")

  console.log(title)

  return (
    <Layout>
      <Seo title="Home" />
      <Hero pageConfig={{ ...pageConfig, title: title }}>
        <div style={{ marginTop: "20px" }}>
          <Button
            variant="solid"
            to="/services"
            onClick={() => navigate("services")}
          >
            View Services
          </Button>
        </div>
      </Hero>

      <div style={{ textAlign: "center", padding: "120px 0" }}>
        Coming soon...
      </div>
    </Layout>
  )
}

export default IndexPage

export const TitleText = graphql`
  query Title {
    allPrismicHomepage {
      edges {
        node {
          data {
            title {
              text
            }
          }
        }
      }
    }
  }
`
